import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { RootState } from "../../store";
import classes from "./LandingPage.module.css";

const BASE = "/api";

type Props = {};

const LandingPage: React.FC<Props> = () => {
  const { introHeading, introContent, heroImage, updateTime, landingPage } =
    useSelector((state: RootState) => state.pod.pod);
  const resourceName = useSelector(
    (state: RootState) => state.pod.resourceName
  );

  const isActiveLandingPage = () => {
    const todayTimestamp = new Date().getTime();
    if (
      todayTimestamp >= landingPage?.startTime &&
      todayTimestamp <= landingPage?.endTime
    ) {
      return true;
    }
    return false;
  };

  return (
    <div className={classes.container}>
      <div className={classes.bannerContainer}>
        <div className={classes.textContainer}>
          <div className={classes.heading}>{introHeading}</div>
          <div className={classes.introContent}>{introContent}</div>
        </div>
        <div className={classes.imgContainer}>
          <div>
            {heroImage && (
              <img
                src={`${BASE}${heroImage}?${updateTime}&tenantId=${resourceName}`}
                alt=''
              />
            )}
          </div>
        </div>
      </div>
      <div className={classes.main}>
        <iframe
          title='landing page'
          src={isActiveLandingPage() ? landingPage?.pageLink : ""}
          frameBorder='0'
          scrolling='yes'
          width={"100%"}
          height={"100%"}
        />
      </div>
    </div>
  );
};
export default LandingPage;
